/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
  JSON: {};
};

export type ConfigurationStrategiesUpdateInput = {
  max_day_profit?: InputMaybe<Scalars['Float']>;
  min_day_profit?: InputMaybe<Scalars['Float']>;
};

export type ConfigurationStrategy = {
  __typename?: 'ConfigurationStrategy';
  id: Scalars['ID'];
  max_day_profit?: Maybe<Scalars['Float']>;
  min_day_profit?: Maybe<Scalars['Float']>;
};

export type ConfigurationStrategyWhereInput = {
  created_at?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  max_day_profit?: InputMaybe<Scalars['Float']>;
  min_day_profit?: InputMaybe<Scalars['Float']>;
  updated_at?: InputMaybe<DateTimeNullableFilter>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<DateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type FlushMetaApiCloudAccountResponse = {
  __typename?: 'FlushMetaApiCloudAccountResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type HistoryStrategiesResponse = {
  __typename?: 'HistoryStrategiesResponse';
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<StrategyHistory>>>;
};

export type HistoryStrategyOrderInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type HistoryStrategyWhereInput = {
  created_at?: InputMaybe<DateTimeNullableFilter>;
  new_value?: InputMaybe<Scalars['Int']>;
  old_value?: InputMaybe<Scalars['Int']>;
  strategy?: InputMaybe<StrategyWhereInput>;
  type?: InputMaybe<StrategyType>;
  updated_at?: InputMaybe<DateTimeNullableFilter>;
};

export type IdFilter = {
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
};

export type MetaApiCloudAccount = {
  __typename?: 'MetaApiCloudAccount';
  account_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  login?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  server?: Maybe<Scalars['String']>;
  suspended_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type MetaApiCloudAccountCreateInput = {
  account_id?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  login?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  server?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
  version?: InputMaybe<Scalars['Int']>;
};

export type MetaApiCloudAccountRelateToOneForUpdateInput = {
  create?: InputMaybe<MetaApiCloudAccountCreateInput>;
  update?: InputMaybe<MetaApiCloudAccountUpdateWhereInput>;
};

export type MetaApiCloudAccountUpdateInput = {
  account_id?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  login?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  server?: InputMaybe<Scalars['String']>;
  suspended_at?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
  version?: InputMaybe<Scalars['Int']>;
};

export type MetaApiCloudAccountUpdateWhereInput = {
  data?: InputMaybe<MetaApiCloudAccountUpdateInput>;
};

export type MetaApiCloudAccountWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type MetaApiCloudAccountsWhereInput = {
  user_id?: InputMaybe<Scalars['String']>;
};

export type MetaApiCloudMetric = {
  __typename?: 'MetaApiCloudMetric';
  balance?: Maybe<Scalars['Int']>;
  best_pair?: Maybe<Scalars['JSON']>;
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pips?: Maybe<Scalars['Int']>;
  profit?: Maybe<Scalars['Int']>;
  trades_close_in_lose?: Maybe<Scalars['Int']>;
  trades_close_in_lose_difference?: Maybe<Scalars['Int']>;
  trades_close_in_profit?: Maybe<Scalars['Int']>;
  trades_close_in_profit_difference?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
  variation_pair?: Maybe<Scalars['Int']>;
  variation_trade_close_in_profit?: Maybe<Scalars['Int']>;
  variation_trades_close_in_lose?: Maybe<Scalars['Int']>;
};

export type MetaApiCloudMetricsWhereInput = {
  user_id?: InputMaybe<Scalars['String']>;
};

export type MetaTraderPosition = {
  __typename?: 'MetaTraderPosition';
  id?: Maybe<Scalars['Int']>;
  profit?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  closeMetaTraderPositions?: Maybe<Array<Maybe<MetaTraderPosition>>>;
  createMetaApiCloudAccount?: Maybe<MetaApiCloudAccount>;
  createStrategy?: Maybe<Strategy>;
  deleteStrategy?: Maybe<Strategy>;
  deleteUser?: Maybe<User>;
  flushMetaApiCloudAccount?: Maybe<FlushMetaApiCloudAccountResponse>;
  selectedRisk?: Maybe<Risk>;
  updateConfigurationStrategy?: Maybe<ConfigurationStrategy>;
  updateMetaApiCloudAccount?: Maybe<MetaApiCloudAccount>;
  updateStrategy?: Maybe<Strategy>;
  updateUser?: Maybe<User>;
};


export type MutationCloseMetaTraderPositionsArgs = {
  data?: InputMaybe<ClosePositionsInput>;
};


export type MutationCreateMetaApiCloudAccountArgs = {
  data?: InputMaybe<MetaApiCloudAccountCreateInput>;
};


export type MutationCreateStrategyArgs = {
  data?: InputMaybe<StrategiesCreateInput>;
};


export type MutationDeleteStrategyArgs = {
  where?: InputMaybe<StrategyWhereUniqueInput>;
};


export type MutationDeleteUserArgs = {
  where?: InputMaybe<UserWhereUniqueInput>;
};


export type MutationSelectedRiskArgs = {
  data?: InputMaybe<UpdateRiskInput>;
  where?: InputMaybe<RiskWhereUniqueInput>;
};


export type MutationUpdateConfigurationStrategyArgs = {
  data?: InputMaybe<ConfigurationStrategiesUpdateInput>;
  where?: InputMaybe<ConfigurationStrategyWhereInput>;
};


export type MutationUpdateMetaApiCloudAccountArgs = {
  data?: InputMaybe<MetaApiCloudAccountUpdateInput>;
  where?: InputMaybe<MetaApiCloudAccountWhereUniqueInput>;
};


export type MutationUpdateStrategyArgs = {
  data?: InputMaybe<StrategiesUpdateInput>;
  where?: InputMaybe<StrategyWhereUniqueInput>;
};


export type MutationUpdateUserArgs = {
  data?: InputMaybe<UserUpdateInput>;
  where?: InputMaybe<UserWhereUniqueInput>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  configurationStrategies?: Maybe<ConfigurationStrategy>;
  currentUser?: Maybe<User>;
  metaApiCloudAccount?: Maybe<MetaApiCloudAccount>;
  metaApiCloudMetrics?: Maybe<MetaApiCloudMetric>;
  risks?: Maybe<RisksResponse>;
  strategies?: Maybe<StrategiesResponse>;
  strategy?: Maybe<Strategy>;
  strategyHistories?: Maybe<HistoryStrategiesResponse>;
  users?: Maybe<UsersResponse>;
};


export type QueryConfigurationStrategiesArgs = {
  where?: InputMaybe<ConfigurationStrategyWhereInput>;
};


export type QueryMetaApiCloudAccountArgs = {
  where?: InputMaybe<MetaApiCloudAccountsWhereInput>;
};


export type QueryMetaApiCloudMetricsArgs = {
  where?: InputMaybe<MetaApiCloudMetricsWhereInput>;
};


export type QueryRisksArgs = {
  orderBy?: InputMaybe<Array<RiskOrderInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RiskWhereInput>;
};


export type QueryStrategiesArgs = {
  orderBy?: InputMaybe<Array<StrategyOrderInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StrategyWhereInput>;
};


export type QueryStrategyArgs = {
  where?: InputMaybe<StrategyWhereInput>;
};


export type QueryStrategyHistoriesArgs = {
  orderBy?: InputMaybe<Array<HistoryStrategyOrderInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HistoryStrategyWhereInput>;
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<Array<UserOrderInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Risk = {
  __typename?: 'Risk';
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  is_editable?: Maybe<Scalars['Boolean']>;
  status?: Maybe<RiskStatus>;
  updated_at?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type RiskOrderInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum RiskStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type RiskWhereInput = {
  created_at?: InputMaybe<StringFilter>;
  is_editable?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<StringFilter>;
};

export type RiskWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type RisksResponse = {
  __typename?: 'RisksResponse';
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<Risk>>>;
};

export type Role = {
  __typename?: 'Role';
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<UserRoles>;
  updated_at?: Maybe<Scalars['String']>;
};

export type RolesOnUsers = {
  __typename?: 'RolesOnUsers';
  role?: Maybe<Role>;
  role_id?: Maybe<Scalars['Int']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StrategiesCreateInput = {
  against_movement?: InputMaybe<Scalars['Float']>;
  cycles?: InputMaybe<Scalars['Int']>;
  favor_movement?: InputMaybe<Scalars['Float']>;
  red_against?: InputMaybe<Scalars['Float']>;
  safety_loss?: InputMaybe<Scalars['Float']>;
  safety_profit?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<StrategyStatus>;
  symbol?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['JSON']>;
};

export type StrategiesResponse = {
  __typename?: 'StrategiesResponse';
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<Strategy>>>;
};

export type StrategiesUpdateInput = {
  against_movement?: InputMaybe<Scalars['Float']>;
  cycles?: InputMaybe<Scalars['Int']>;
  favor_movement?: InputMaybe<Scalars['Float']>;
  red_against?: InputMaybe<Scalars['Float']>;
  safety_loss?: InputMaybe<Scalars['Float']>;
  safety_profit?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<StrategyStatus>;
  symbol?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['JSON']>;
};

export type Strategy = {
  __typename?: 'Strategy';
  against_movement?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['DateTime']>;
  cycles?: Maybe<Scalars['Int']>;
  favor_movement?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  max_day_profit?: Maybe<Scalars['Float']>;
  min_day_profit?: Maybe<Scalars['Float']>;
  red_against?: Maybe<Scalars['Float']>;
  safety_loss?: Maybe<Scalars['Float']>;
  safety_profit?: Maybe<Scalars['Float']>;
  status?: Maybe<StrategyStatus>;
  strategy_history?: Maybe<Array<Maybe<StrategyHistory>>>;
  symbol?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['JSON']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type StrategyHistory = {
  __typename?: 'StrategyHistory';
  created_at?: Maybe<Scalars['DateTime']>;
  new_value?: Maybe<Scalars['Float']>;
  old_value?: Maybe<Scalars['Float']>;
  strategy?: Maybe<Strategy>;
  strategy_id?: Maybe<Scalars['String']>;
  type?: Maybe<StrategyType>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type StrategyOrderInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum StrategyStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum StrategyType {
  Against = 'AGAINST',
  Cycles = 'CYCLES',
  Favor = 'FAVOR',
  MaxDayProfit = 'MAX_DAY_PROFIT',
  MinDayProfit = 'MIN_DAY_PROFIT',
  RedAgainst = 'RED_AGAINST',
  SafetyLoss = 'SAFETY_LOSS',
  SafetyProfit = 'SAFETY_PROFIT'
}

export type StrategyWhereInput = {
  against_movement?: InputMaybe<Scalars['Float']>;
  created_at?: InputMaybe<DateTimeNullableFilter>;
  cycles?: InputMaybe<Scalars['Int']>;
  favor_movement?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<IdFilter>;
  max_day_profit?: InputMaybe<Scalars['Float']>;
  min_day_profit?: InputMaybe<Scalars['Float']>;
  red_against?: InputMaybe<Scalars['Float']>;
  safety_loss?: InputMaybe<Scalars['Float']>;
  safety_profit?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<StrategyStatus>;
  time?: InputMaybe<Scalars['JSON']>;
  updated_at?: InputMaybe<DateTimeNullableFilter>;
};

export type StrategyWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  matches?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type UpdateRiskInput = {
  value?: InputMaybe<Scalars['Float']>;
};

export type User = {
  __typename?: 'User';
  created_at?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  meta_api_cloud_account?: Maybe<MetaApiCloudAccount>;
  meta_api_cloud_metrics?: Maybe<MetaApiCloudMetric>;
  phone?: Maybe<Scalars['String']>;
  roles_on_users?: Maybe<Array<Maybe<RolesOnUsers>>>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type UserOrderInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type UserRelateToOneForUpdateInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
};

export enum UserRoles {
  Master = 'MASTER',
  User = 'USER'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type UserUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  meta_api_cloud_account?: InputMaybe<MetaApiCloudAccountRelateToOneForUpdateInput>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
};

export type UserWhereInput = {
  created_at?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  first_name?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeNullableFilter>;
};

export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<User>>>;
};

export type ClosePositionsInput = {
  symbol?: InputMaybe<Scalars['String']>;
};

export type MetaApiCloudMetricFragmentFragment = { __typename?: 'MetaApiCloudMetric', best_pair: {} | null, created_at: string | null, id: string | null, pips: number | null, trades_close_in_lose: number | null, balance: number | null, trades_close_in_lose_difference: number | null, trades_close_in_profit: number | null, trades_close_in_profit_difference: number | null, updated_at: string | null, profit: number | null, variation_pair: number | null, variation_trade_close_in_profit: number | null, variation_trades_close_in_lose: number | null };

export type MetaApiCloudAccountFragmentFragment = { __typename?: 'MetaApiCloudAccount', account_id: string | null, created_at: string | null, currency: string | null, id: string | null, login: string | null, name: string | null, server: string | null, region: string | null, updated_at: string | null, version: number | null, suspended_at: string | null };

export type CreateMetaApiCloudAccountMutationVariables = Exact<{
  data?: InputMaybe<MetaApiCloudAccountCreateInput>;
}>;


export type CreateMetaApiCloudAccountMutation = { __typename?: 'Mutation', createMetaApiCloudAccount: { __typename?: 'MetaApiCloudAccount', id: string | null } | null };

export type UpdateMetaApiCloudAccountMutationVariables = Exact<{
  data?: InputMaybe<MetaApiCloudAccountUpdateInput>;
  where?: InputMaybe<MetaApiCloudAccountWhereUniqueInput>;
}>;


export type UpdateMetaApiCloudAccountMutation = { __typename?: 'Mutation', updateMetaApiCloudAccount: { __typename?: 'MetaApiCloudAccount', id: string | null } | null };

export type CloseMetaTraderPositionsMutationVariables = Exact<{
  data?: InputMaybe<ClosePositionsInput>;
}>;


export type CloseMetaTraderPositionsMutation = { __typename?: 'Mutation', closeMetaTraderPositions: Array<{ __typename?: 'MetaTraderPosition', id: number | null, profit: number | null, type: string | null } | null> | null };

export type MetaApiCloudMetricsQueryVariables = Exact<{
  where?: InputMaybe<MetaApiCloudMetricsWhereInput>;
}>;


export type MetaApiCloudMetricsQuery = { __typename?: 'Query', metaApiCloudMetrics: { __typename?: 'MetaApiCloudMetric', best_pair: {} | null, created_at: string | null, id: string | null, pips: number | null, trades_close_in_lose: number | null, balance: number | null, trades_close_in_lose_difference: number | null, trades_close_in_profit: number | null, trades_close_in_profit_difference: number | null, updated_at: string | null, profit: number | null, variation_pair: number | null, variation_trade_close_in_profit: number | null, variation_trades_close_in_lose: number | null } | null };

export type MetaApiCloudAccountQueryVariables = Exact<{
  where?: InputMaybe<MetaApiCloudAccountsWhereInput>;
}>;


export type MetaApiCloudAccountQuery = { __typename?: 'Query', metaApiCloudAccount: { __typename?: 'MetaApiCloudAccount', account_id: string | null, created_at: string | null, currency: string | null, id: string | null, login: string | null, name: string | null, server: string | null, region: string | null, updated_at: string | null, version: number | null, suspended_at: string | null } | null };

export type FlushMetaApiCloudAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type FlushMetaApiCloudAccountMutation = { __typename?: 'Mutation', flushMetaApiCloudAccount: { __typename?: 'FlushMetaApiCloudAccountResponse', success: boolean | null } | null };

export type RisksQueryVariables = Exact<{
  where?: InputMaybe<RiskWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RiskOrderInput> | RiskOrderInput>;
}>;


export type RisksQuery = { __typename?: 'Query', risks: { __typename?: 'RisksResponse', count: number | null, items: Array<{ __typename?: 'Risk', created_at: string | null, description: string | null, id: string | null, is_editable: boolean | null, status: RiskStatus | null, updated_at: string | null, value: number | null } | null> | null } | null };

export type SelectedRiskMutationVariables = Exact<{
  where?: InputMaybe<RiskWhereUniqueInput>;
  data?: InputMaybe<UpdateRiskInput>;
}>;


export type SelectedRiskMutation = { __typename?: 'Mutation', selectedRisk: { __typename?: 'Risk', id: string | null } | null };

export type StrategiesQueryVariables = Exact<{
  where?: InputMaybe<StrategyWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StrategyOrderInput> | StrategyOrderInput>;
}>;


export type StrategiesQuery = { __typename?: 'Query', strategies: { __typename?: 'StrategiesResponse', count: number | null, items: Array<{ __typename?: 'Strategy', id: string, favor_movement: number | null, cycles: number | null, against_movement: number | null, red_against: number | null, safety_profit: number | null, safety_loss: number | null, status: StrategyStatus | null, symbol: string | null, time: {} | null } | null> | null } | null };

export type ConfigurationStrategiesAndStrategiesQueryVariables = Exact<{
  where?: InputMaybe<StrategyWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StrategyOrderInput> | StrategyOrderInput>;
  configurationStrategyWhere?: InputMaybe<ConfigurationStrategyWhereInput>;
}>;


export type ConfigurationStrategiesAndStrategiesQuery = { __typename?: 'Query', strategies: { __typename?: 'StrategiesResponse', count: number | null, items: Array<{ __typename?: 'Strategy', id: string, favor_movement: number | null, cycles: number | null, against_movement: number | null, red_against: number | null, safety_profit: number | null, safety_loss: number | null, status: StrategyStatus | null, symbol: string | null, time: {} | null } | null> | null } | null, configurationStrategies: { __typename?: 'ConfigurationStrategy', id: string, max_day_profit: number | null, min_day_profit: number | null } | null };

export type StrategyHistoriesQueryVariables = Exact<{
  where?: InputMaybe<HistoryStrategyWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HistoryStrategyOrderInput> | HistoryStrategyOrderInput>;
}>;


export type StrategyHistoriesQuery = { __typename?: 'Query', strategyHistories: { __typename?: 'HistoryStrategiesResponse', count: number | null, items: Array<{ __typename?: 'StrategyHistory', new_value: number | null, created_at: string | null, old_value: number | null, type: StrategyType | null, strategy_id: string | null, updated_at: string | null } | null> | null } | null };

export type UpdateStrategyMutationVariables = Exact<{
  data?: InputMaybe<StrategiesUpdateInput>;
  where?: InputMaybe<StrategyWhereUniqueInput>;
}>;


export type UpdateStrategyMutation = { __typename?: 'Mutation', updateStrategy: { __typename?: 'Strategy', id: string, status: StrategyStatus | null } | null };

export type UpdateConfigurationStrategyAndStrategyMutationVariables = Exact<{
  data?: InputMaybe<StrategiesUpdateInput>;
  where?: InputMaybe<StrategyWhereUniqueInput>;
  data2?: InputMaybe<ConfigurationStrategiesUpdateInput>;
  where2?: InputMaybe<ConfigurationStrategyWhereInput>;
}>;


export type UpdateConfigurationStrategyAndStrategyMutation = { __typename?: 'Mutation', updateStrategy: { __typename?: 'Strategy', id: string, status: StrategyStatus | null } | null, updateConfigurationStrategy: { __typename?: 'ConfigurationStrategy', id: string } | null };

export type CreateStrategyMutationVariables = Exact<{
  data?: InputMaybe<StrategiesCreateInput>;
}>;


export type CreateStrategyMutation = { __typename?: 'Mutation', createStrategy: { __typename?: 'Strategy', id: string, status: StrategyStatus | null } | null };

export type DeleteStrategyMutationVariables = Exact<{
  where?: InputMaybe<StrategyWhereUniqueInput>;
}>;


export type DeleteStrategyMutation = { __typename?: 'Mutation', deleteStrategy: { __typename?: 'Strategy', id: string } | null };

export type UserFragmentFragment = { __typename?: 'User', created_at: string | null, email: string | null, first_name: string | null, id: string | null, last_name: string | null, phone: string | null, status: string | null, updated_at: string | null, meta_api_cloud_account: { __typename?: 'MetaApiCloudAccount', account_id: string | null, created_at: string | null, currency: string | null, id: string | null, login: string | null, name: string | null, server: string | null, region: string | null, updated_at: string | null, version: number | null, suspended_at: string | null } | null, meta_api_cloud_metrics: { __typename?: 'MetaApiCloudMetric', best_pair: {} | null, created_at: string | null, id: string | null, pips: number | null, trades_close_in_lose: number | null, balance: number | null, trades_close_in_lose_difference: number | null, trades_close_in_profit: number | null, trades_close_in_profit_difference: number | null, updated_at: string | null, profit: number | null, variation_pair: number | null, variation_trade_close_in_profit: number | null, variation_trades_close_in_lose: number | null } | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role: { __typename?: 'Role', id: string | null, name: UserRoles | null } | null } | null> | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', created_at: string | null, email: string | null, first_name: string | null, id: string | null, last_name: string | null, phone: string | null, status: string | null, updated_at: string | null, meta_api_cloud_account: { __typename?: 'MetaApiCloudAccount', account_id: string | null, created_at: string | null, currency: string | null, id: string | null, login: string | null, name: string | null, server: string | null, region: string | null, updated_at: string | null, version: number | null, suspended_at: string | null } | null, meta_api_cloud_metrics: { __typename?: 'MetaApiCloudMetric', best_pair: {} | null, created_at: string | null, id: string | null, pips: number | null, trades_close_in_lose: number | null, balance: number | null, trades_close_in_lose_difference: number | null, trades_close_in_profit: number | null, trades_close_in_profit_difference: number | null, updated_at: string | null, profit: number | null, variation_pair: number | null, variation_trade_close_in_profit: number | null, variation_trades_close_in_lose: number | null } | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role: { __typename?: 'Role', id: string | null, name: UserRoles | null } | null } | null> | null } | null };

export type DeleteUserMutationVariables = Exact<{
  where?: InputMaybe<UserWhereUniqueInput>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', created_at: string | null, email: string | null, first_name: string | null, id: string | null, last_name: string | null, phone: string | null, status: string | null, updated_at: string | null, meta_api_cloud_account: { __typename?: 'MetaApiCloudAccount', account_id: string | null, created_at: string | null, currency: string | null, id: string | null, login: string | null, name: string | null, server: string | null, region: string | null, updated_at: string | null, version: number | null, suspended_at: string | null } | null, meta_api_cloud_metrics: { __typename?: 'MetaApiCloudMetric', best_pair: {} | null, created_at: string | null, id: string | null, pips: number | null, trades_close_in_lose: number | null, balance: number | null, trades_close_in_lose_difference: number | null, trades_close_in_profit: number | null, trades_close_in_profit_difference: number | null, updated_at: string | null, profit: number | null, variation_pair: number | null, variation_trade_close_in_profit: number | null, variation_trades_close_in_lose: number | null } | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role: { __typename?: 'Role', id: string | null, name: UserRoles | null } | null } | null> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  data?: InputMaybe<UserUpdateInput>;
  where?: InputMaybe<UserWhereUniqueInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string | null } | null };

export type UsersQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOrderInput> | UserOrderInput>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResponse', count: number | null, items: Array<{ __typename?: 'User', created_at: string | null, email: string | null, first_name: string | null, id: string | null, last_name: string | null, phone: string | null, status: string | null, updated_at: string | null, meta_api_cloud_account: { __typename?: 'MetaApiCloudAccount', account_id: string | null, created_at: string | null, currency: string | null, id: string | null, login: string | null, name: string | null, server: string | null, region: string | null, updated_at: string | null, version: number | null, suspended_at: string | null } | null, meta_api_cloud_metrics: { __typename?: 'MetaApiCloudMetric', best_pair: {} | null, created_at: string | null, id: string | null, pips: number | null, trades_close_in_lose: number | null, balance: number | null, trades_close_in_lose_difference: number | null, trades_close_in_profit: number | null, trades_close_in_profit_difference: number | null, updated_at: string | null, profit: number | null, variation_pair: number | null, variation_trade_close_in_profit: number | null, variation_trades_close_in_lose: number | null } | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role: { __typename?: 'Role', id: string | null, name: UserRoles | null } | null } | null> | null } | null> | null } | null };

export const MetaApiCloudAccountFragmentFragmentDoc = gql`
    fragment MetaApiCloudAccountFragment on MetaApiCloudAccount {
  account_id
  created_at
  currency
  id
  login
  name
  server
  region
  updated_at
  version
  suspended_at
}
    `;
export const MetaApiCloudMetricFragmentFragmentDoc = gql`
    fragment MetaApiCloudMetricFragment on MetaApiCloudMetric {
  best_pair
  created_at
  id
  pips
  trades_close_in_lose
  balance
  trades_close_in_lose_difference
  trades_close_in_profit
  trades_close_in_profit_difference
  updated_at
  profit
  variation_pair
  variation_trade_close_in_profit
  variation_trades_close_in_lose
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  created_at
  email
  first_name
  id
  last_name
  meta_api_cloud_account {
    ...MetaApiCloudAccountFragment
  }
  meta_api_cloud_metrics {
    ...MetaApiCloudMetricFragment
  }
  roles_on_users {
    role {
      id
      name
    }
  }
  phone
  status
  updated_at
}
    ${MetaApiCloudAccountFragmentFragmentDoc}
${MetaApiCloudMetricFragmentFragmentDoc}`;
export const CreateMetaApiCloudAccountDocument = gql`
    mutation CreateMetaApiCloudAccount($data: MetaApiCloudAccountCreateInput) {
  createMetaApiCloudAccount(data: $data) {
    id
  }
}
    `;
export type CreateMetaApiCloudAccountMutationFn = Apollo.MutationFunction<CreateMetaApiCloudAccountMutation, CreateMetaApiCloudAccountMutationVariables>;

/**
 * __useCreateMetaApiCloudAccountMutation__
 *
 * To run a mutation, you first call `useCreateMetaApiCloudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetaApiCloudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetaApiCloudAccountMutation, { data, loading, error }] = useCreateMetaApiCloudAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMetaApiCloudAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetaApiCloudAccountMutation, CreateMetaApiCloudAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetaApiCloudAccountMutation, CreateMetaApiCloudAccountMutationVariables>(CreateMetaApiCloudAccountDocument, options);
      }
export type CreateMetaApiCloudAccountMutationHookResult = ReturnType<typeof useCreateMetaApiCloudAccountMutation>;
export type CreateMetaApiCloudAccountMutationResult = Apollo.MutationResult<CreateMetaApiCloudAccountMutation>;
export type CreateMetaApiCloudAccountMutationOptions = Apollo.BaseMutationOptions<CreateMetaApiCloudAccountMutation, CreateMetaApiCloudAccountMutationVariables>;
export const UpdateMetaApiCloudAccountDocument = gql`
    mutation UpdateMetaApiCloudAccount($data: MetaApiCloudAccountUpdateInput, $where: MetaApiCloudAccountWhereUniqueInput) {
  updateMetaApiCloudAccount(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateMetaApiCloudAccountMutationFn = Apollo.MutationFunction<UpdateMetaApiCloudAccountMutation, UpdateMetaApiCloudAccountMutationVariables>;

/**
 * __useUpdateMetaApiCloudAccountMutation__
 *
 * To run a mutation, you first call `useUpdateMetaApiCloudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetaApiCloudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetaApiCloudAccountMutation, { data, loading, error }] = useUpdateMetaApiCloudAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateMetaApiCloudAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetaApiCloudAccountMutation, UpdateMetaApiCloudAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetaApiCloudAccountMutation, UpdateMetaApiCloudAccountMutationVariables>(UpdateMetaApiCloudAccountDocument, options);
      }
export type UpdateMetaApiCloudAccountMutationHookResult = ReturnType<typeof useUpdateMetaApiCloudAccountMutation>;
export type UpdateMetaApiCloudAccountMutationResult = Apollo.MutationResult<UpdateMetaApiCloudAccountMutation>;
export type UpdateMetaApiCloudAccountMutationOptions = Apollo.BaseMutationOptions<UpdateMetaApiCloudAccountMutation, UpdateMetaApiCloudAccountMutationVariables>;
export const CloseMetaTraderPositionsDocument = gql`
    mutation CloseMetaTraderPositions($data: closePositionsInput) {
  closeMetaTraderPositions(data: $data) {
    id
    profit
    type
  }
}
    `;
export type CloseMetaTraderPositionsMutationFn = Apollo.MutationFunction<CloseMetaTraderPositionsMutation, CloseMetaTraderPositionsMutationVariables>;

/**
 * __useCloseMetaTraderPositionsMutation__
 *
 * To run a mutation, you first call `useCloseMetaTraderPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseMetaTraderPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeMetaTraderPositionsMutation, { data, loading, error }] = useCloseMetaTraderPositionsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCloseMetaTraderPositionsMutation(baseOptions?: Apollo.MutationHookOptions<CloseMetaTraderPositionsMutation, CloseMetaTraderPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseMetaTraderPositionsMutation, CloseMetaTraderPositionsMutationVariables>(CloseMetaTraderPositionsDocument, options);
      }
export type CloseMetaTraderPositionsMutationHookResult = ReturnType<typeof useCloseMetaTraderPositionsMutation>;
export type CloseMetaTraderPositionsMutationResult = Apollo.MutationResult<CloseMetaTraderPositionsMutation>;
export type CloseMetaTraderPositionsMutationOptions = Apollo.BaseMutationOptions<CloseMetaTraderPositionsMutation, CloseMetaTraderPositionsMutationVariables>;
export const MetaApiCloudMetricsDocument = gql`
    query MetaApiCloudMetrics($where: MetaApiCloudMetricsWhereInput) {
  metaApiCloudMetrics(where: $where) {
    ...MetaApiCloudMetricFragment
  }
}
    ${MetaApiCloudMetricFragmentFragmentDoc}`;

/**
 * __useMetaApiCloudMetricsQuery__
 *
 * To run a query within a React component, call `useMetaApiCloudMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaApiCloudMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaApiCloudMetricsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMetaApiCloudMetricsQuery(baseOptions?: Apollo.QueryHookOptions<MetaApiCloudMetricsQuery, MetaApiCloudMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaApiCloudMetricsQuery, MetaApiCloudMetricsQueryVariables>(MetaApiCloudMetricsDocument, options);
      }
export function useMetaApiCloudMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaApiCloudMetricsQuery, MetaApiCloudMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaApiCloudMetricsQuery, MetaApiCloudMetricsQueryVariables>(MetaApiCloudMetricsDocument, options);
        }
export type MetaApiCloudMetricsQueryHookResult = ReturnType<typeof useMetaApiCloudMetricsQuery>;
export type MetaApiCloudMetricsLazyQueryHookResult = ReturnType<typeof useMetaApiCloudMetricsLazyQuery>;
export type MetaApiCloudMetricsQueryResult = Apollo.QueryResult<MetaApiCloudMetricsQuery, MetaApiCloudMetricsQueryVariables>;
export const MetaApiCloudAccountDocument = gql`
    query MetaApiCloudAccount($where: MetaApiCloudAccountsWhereInput) {
  metaApiCloudAccount(where: $where) {
    ...MetaApiCloudAccountFragment
  }
}
    ${MetaApiCloudAccountFragmentFragmentDoc}`;

/**
 * __useMetaApiCloudAccountQuery__
 *
 * To run a query within a React component, call `useMetaApiCloudAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaApiCloudAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaApiCloudAccountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMetaApiCloudAccountQuery(baseOptions?: Apollo.QueryHookOptions<MetaApiCloudAccountQuery, MetaApiCloudAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaApiCloudAccountQuery, MetaApiCloudAccountQueryVariables>(MetaApiCloudAccountDocument, options);
      }
export function useMetaApiCloudAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaApiCloudAccountQuery, MetaApiCloudAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaApiCloudAccountQuery, MetaApiCloudAccountQueryVariables>(MetaApiCloudAccountDocument, options);
        }
export type MetaApiCloudAccountQueryHookResult = ReturnType<typeof useMetaApiCloudAccountQuery>;
export type MetaApiCloudAccountLazyQueryHookResult = ReturnType<typeof useMetaApiCloudAccountLazyQuery>;
export type MetaApiCloudAccountQueryResult = Apollo.QueryResult<MetaApiCloudAccountQuery, MetaApiCloudAccountQueryVariables>;
export const FlushMetaApiCloudAccountDocument = gql`
    mutation FlushMetaApiCloudAccount {
  flushMetaApiCloudAccount {
    success
  }
}
    `;
export type FlushMetaApiCloudAccountMutationFn = Apollo.MutationFunction<FlushMetaApiCloudAccountMutation, FlushMetaApiCloudAccountMutationVariables>;

/**
 * __useFlushMetaApiCloudAccountMutation__
 *
 * To run a mutation, you first call `useFlushMetaApiCloudAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlushMetaApiCloudAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flushMetaApiCloudAccountMutation, { data, loading, error }] = useFlushMetaApiCloudAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useFlushMetaApiCloudAccountMutation(baseOptions?: Apollo.MutationHookOptions<FlushMetaApiCloudAccountMutation, FlushMetaApiCloudAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlushMetaApiCloudAccountMutation, FlushMetaApiCloudAccountMutationVariables>(FlushMetaApiCloudAccountDocument, options);
      }
export type FlushMetaApiCloudAccountMutationHookResult = ReturnType<typeof useFlushMetaApiCloudAccountMutation>;
export type FlushMetaApiCloudAccountMutationResult = Apollo.MutationResult<FlushMetaApiCloudAccountMutation>;
export type FlushMetaApiCloudAccountMutationOptions = Apollo.BaseMutationOptions<FlushMetaApiCloudAccountMutation, FlushMetaApiCloudAccountMutationVariables>;
export const RisksDocument = gql`
    query Risks($where: RiskWhereInput, $take: Int, $skip: Int, $orderBy: [RiskOrderInput!]) {
  risks(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    count
    items {
      created_at
      description
      id
      is_editable
      status
      updated_at
      value
    }
  }
}
    `;

/**
 * __useRisksQuery__
 *
 * To run a query within a React component, call `useRisksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRisksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRisksQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRisksQuery(baseOptions?: Apollo.QueryHookOptions<RisksQuery, RisksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RisksQuery, RisksQueryVariables>(RisksDocument, options);
      }
export function useRisksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RisksQuery, RisksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RisksQuery, RisksQueryVariables>(RisksDocument, options);
        }
export type RisksQueryHookResult = ReturnType<typeof useRisksQuery>;
export type RisksLazyQueryHookResult = ReturnType<typeof useRisksLazyQuery>;
export type RisksQueryResult = Apollo.QueryResult<RisksQuery, RisksQueryVariables>;
export const SelectedRiskDocument = gql`
    mutation SelectedRisk($where: RiskWhereUniqueInput, $data: UpdateRiskInput) {
  selectedRisk(where: $where, data: $data) {
    id
  }
}
    `;
export type SelectedRiskMutationFn = Apollo.MutationFunction<SelectedRiskMutation, SelectedRiskMutationVariables>;

/**
 * __useSelectedRiskMutation__
 *
 * To run a mutation, you first call `useSelectedRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectedRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectedRiskMutation, { data, loading, error }] = useSelectedRiskMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSelectedRiskMutation(baseOptions?: Apollo.MutationHookOptions<SelectedRiskMutation, SelectedRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectedRiskMutation, SelectedRiskMutationVariables>(SelectedRiskDocument, options);
      }
export type SelectedRiskMutationHookResult = ReturnType<typeof useSelectedRiskMutation>;
export type SelectedRiskMutationResult = Apollo.MutationResult<SelectedRiskMutation>;
export type SelectedRiskMutationOptions = Apollo.BaseMutationOptions<SelectedRiskMutation, SelectedRiskMutationVariables>;
export const StrategiesDocument = gql`
    query Strategies($where: StrategyWhereInput, $take: Int, $skip: Int, $orderBy: [StrategyOrderInput!]) {
  strategies(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    count
    items {
      id
      favor_movement
      cycles
      against_movement
      red_against
      safety_profit
      safety_loss
      status
      symbol
      time
    }
  }
}
    `;

/**
 * __useStrategiesQuery__
 *
 * To run a query within a React component, call `useStrategiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrategiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrategiesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useStrategiesQuery(baseOptions?: Apollo.QueryHookOptions<StrategiesQuery, StrategiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StrategiesQuery, StrategiesQueryVariables>(StrategiesDocument, options);
      }
export function useStrategiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrategiesQuery, StrategiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StrategiesQuery, StrategiesQueryVariables>(StrategiesDocument, options);
        }
export type StrategiesQueryHookResult = ReturnType<typeof useStrategiesQuery>;
export type StrategiesLazyQueryHookResult = ReturnType<typeof useStrategiesLazyQuery>;
export type StrategiesQueryResult = Apollo.QueryResult<StrategiesQuery, StrategiesQueryVariables>;
export const ConfigurationStrategiesAndStrategiesDocument = gql`
    query ConfigurationStrategiesAndStrategies($where: StrategyWhereInput, $take: Int, $skip: Int, $orderBy: [StrategyOrderInput!], $configurationStrategyWhere: ConfigurationStrategyWhereInput) {
  strategies(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    count
    items {
      id
      favor_movement
      cycles
      against_movement
      red_against
      safety_profit
      safety_loss
      status
      symbol
      time
    }
  }
  configurationStrategies(where: $configurationStrategyWhere) {
    id
    max_day_profit
    min_day_profit
  }
}
    `;

/**
 * __useConfigurationStrategiesAndStrategiesQuery__
 *
 * To run a query within a React component, call `useConfigurationStrategiesAndStrategiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationStrategiesAndStrategiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationStrategiesAndStrategiesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      configurationStrategyWhere: // value for 'configurationStrategyWhere'
 *   },
 * });
 */
export function useConfigurationStrategiesAndStrategiesQuery(baseOptions?: Apollo.QueryHookOptions<ConfigurationStrategiesAndStrategiesQuery, ConfigurationStrategiesAndStrategiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationStrategiesAndStrategiesQuery, ConfigurationStrategiesAndStrategiesQueryVariables>(ConfigurationStrategiesAndStrategiesDocument, options);
      }
export function useConfigurationStrategiesAndStrategiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationStrategiesAndStrategiesQuery, ConfigurationStrategiesAndStrategiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationStrategiesAndStrategiesQuery, ConfigurationStrategiesAndStrategiesQueryVariables>(ConfigurationStrategiesAndStrategiesDocument, options);
        }
export type ConfigurationStrategiesAndStrategiesQueryHookResult = ReturnType<typeof useConfigurationStrategiesAndStrategiesQuery>;
export type ConfigurationStrategiesAndStrategiesLazyQueryHookResult = ReturnType<typeof useConfigurationStrategiesAndStrategiesLazyQuery>;
export type ConfigurationStrategiesAndStrategiesQueryResult = Apollo.QueryResult<ConfigurationStrategiesAndStrategiesQuery, ConfigurationStrategiesAndStrategiesQueryVariables>;
export const StrategyHistoriesDocument = gql`
    query StrategyHistories($where: HistoryStrategyWhereInput, $take: Int, $skip: Int, $orderBy: [HistoryStrategyOrderInput!]) {
  strategyHistories(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    count
    items {
      new_value
      created_at
      old_value
      type
      strategy_id
      updated_at
    }
  }
}
    `;

/**
 * __useStrategyHistoriesQuery__
 *
 * To run a query within a React component, call `useStrategyHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrategyHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrategyHistoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useStrategyHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<StrategyHistoriesQuery, StrategyHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StrategyHistoriesQuery, StrategyHistoriesQueryVariables>(StrategyHistoriesDocument, options);
      }
export function useStrategyHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrategyHistoriesQuery, StrategyHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StrategyHistoriesQuery, StrategyHistoriesQueryVariables>(StrategyHistoriesDocument, options);
        }
export type StrategyHistoriesQueryHookResult = ReturnType<typeof useStrategyHistoriesQuery>;
export type StrategyHistoriesLazyQueryHookResult = ReturnType<typeof useStrategyHistoriesLazyQuery>;
export type StrategyHistoriesQueryResult = Apollo.QueryResult<StrategyHistoriesQuery, StrategyHistoriesQueryVariables>;
export const UpdateStrategyDocument = gql`
    mutation UpdateStrategy($data: StrategiesUpdateInput, $where: StrategyWhereUniqueInput) {
  updateStrategy(data: $data, where: $where) {
    id
    status
  }
}
    `;
export type UpdateStrategyMutationFn = Apollo.MutationFunction<UpdateStrategyMutation, UpdateStrategyMutationVariables>;

/**
 * __useUpdateStrategyMutation__
 *
 * To run a mutation, you first call `useUpdateStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStrategyMutation, { data, loading, error }] = useUpdateStrategyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateStrategyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStrategyMutation, UpdateStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStrategyMutation, UpdateStrategyMutationVariables>(UpdateStrategyDocument, options);
      }
export type UpdateStrategyMutationHookResult = ReturnType<typeof useUpdateStrategyMutation>;
export type UpdateStrategyMutationResult = Apollo.MutationResult<UpdateStrategyMutation>;
export type UpdateStrategyMutationOptions = Apollo.BaseMutationOptions<UpdateStrategyMutation, UpdateStrategyMutationVariables>;
export const UpdateConfigurationStrategyAndStrategyDocument = gql`
    mutation UpdateConfigurationStrategyAndStrategy($data: StrategiesUpdateInput, $where: StrategyWhereUniqueInput, $data2: ConfigurationStrategiesUpdateInput, $where2: ConfigurationStrategyWhereInput) {
  updateStrategy(data: $data, where: $where) {
    id
    status
  }
  updateConfigurationStrategy(data: $data2, where: $where2) {
    id
  }
}
    `;
export type UpdateConfigurationStrategyAndStrategyMutationFn = Apollo.MutationFunction<UpdateConfigurationStrategyAndStrategyMutation, UpdateConfigurationStrategyAndStrategyMutationVariables>;

/**
 * __useUpdateConfigurationStrategyAndStrategyMutation__
 *
 * To run a mutation, you first call `useUpdateConfigurationStrategyAndStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfigurationStrategyAndStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfigurationStrategyAndStrategyMutation, { data, loading, error }] = useUpdateConfigurationStrategyAndStrategyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *      data2: // value for 'data2'
 *      where2: // value for 'where2'
 *   },
 * });
 */
export function useUpdateConfigurationStrategyAndStrategyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConfigurationStrategyAndStrategyMutation, UpdateConfigurationStrategyAndStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConfigurationStrategyAndStrategyMutation, UpdateConfigurationStrategyAndStrategyMutationVariables>(UpdateConfigurationStrategyAndStrategyDocument, options);
      }
export type UpdateConfigurationStrategyAndStrategyMutationHookResult = ReturnType<typeof useUpdateConfigurationStrategyAndStrategyMutation>;
export type UpdateConfigurationStrategyAndStrategyMutationResult = Apollo.MutationResult<UpdateConfigurationStrategyAndStrategyMutation>;
export type UpdateConfigurationStrategyAndStrategyMutationOptions = Apollo.BaseMutationOptions<UpdateConfigurationStrategyAndStrategyMutation, UpdateConfigurationStrategyAndStrategyMutationVariables>;
export const CreateStrategyDocument = gql`
    mutation CreateStrategy($data: StrategiesCreateInput) {
  createStrategy(data: $data) {
    id
    status
  }
}
    `;
export type CreateStrategyMutationFn = Apollo.MutationFunction<CreateStrategyMutation, CreateStrategyMutationVariables>;

/**
 * __useCreateStrategyMutation__
 *
 * To run a mutation, you first call `useCreateStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStrategyMutation, { data, loading, error }] = useCreateStrategyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStrategyMutation(baseOptions?: Apollo.MutationHookOptions<CreateStrategyMutation, CreateStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStrategyMutation, CreateStrategyMutationVariables>(CreateStrategyDocument, options);
      }
export type CreateStrategyMutationHookResult = ReturnType<typeof useCreateStrategyMutation>;
export type CreateStrategyMutationResult = Apollo.MutationResult<CreateStrategyMutation>;
export type CreateStrategyMutationOptions = Apollo.BaseMutationOptions<CreateStrategyMutation, CreateStrategyMutationVariables>;
export const DeleteStrategyDocument = gql`
    mutation DeleteStrategy($where: StrategyWhereUniqueInput) {
  deleteStrategy(where: $where) {
    id
  }
}
    `;
export type DeleteStrategyMutationFn = Apollo.MutationFunction<DeleteStrategyMutation, DeleteStrategyMutationVariables>;

/**
 * __useDeleteStrategyMutation__
 *
 * To run a mutation, you first call `useDeleteStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStrategyMutation, { data, loading, error }] = useDeleteStrategyMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteStrategyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStrategyMutation, DeleteStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStrategyMutation, DeleteStrategyMutationVariables>(DeleteStrategyDocument, options);
      }
export type DeleteStrategyMutationHookResult = ReturnType<typeof useDeleteStrategyMutation>;
export type DeleteStrategyMutationResult = Apollo.MutationResult<DeleteStrategyMutation>;
export type DeleteStrategyMutationOptions = Apollo.BaseMutationOptions<DeleteStrategyMutation, DeleteStrategyMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($where: UserWhereUniqueInput) {
  deleteUser(where: $where) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($data: UserUpdateInput, $where: UserWhereUniqueInput) {
  updateUser(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UsersDocument = gql`
    query Users($where: UserWhereInput, $take: Int, $skip: Int, $orderBy: [UserOrderInput!]) {
  users(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    count
    items {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;